import { useState } from 'react';
import LStarFilled from '@/app/_components/ui/icons/LStarFilled.svg';

export default function StarRating({ onChange, starValue }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="star-rating">
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className={index <= (hover || starValue) ? 'on' : 'off'}
            onClick={() => onChange(index)}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(starValue)}
          >
            <span>
              <LStarFilled
                fill={index <= (hover || starValue) ? '#FFD659' : '#b2b2b2'}
              />
            </span>
          </button>
        );
      })}
    </div>
  );
}
